// extracted by mini-css-extract-plugin
export default {"ArticleEdit":"jq_a bik_qt bik_a bik_w bik_ea","ArticleEdit__draft":"jq_b bik_vv bik_vc bik_sq bik_so bik_sp bik_rw bik_fi"};